import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { SubscriptionManager } from '@tmx/core';

import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AlertService } from '../auth/services/alert.service';
import { NumericKeyValueState } from '../_models/state/optionUIState';
@Injectable({
  providedIn: 'root',
})
export class DataVersionService implements OnDestroy {
  dataversionSource = new BehaviorSubject<NumericKeyValueState[]>([]);
  dataVersions = this.dataversionSource.asObservable();
  private subscriptionManager = new SubscriptionManager();
  constructor(private http: HttpClient, private alertService: AlertService) {}
  retriveDataVerionList(): Observable<any> {
    const url = `${environment.pcmwsUrl}/pcmversion`;
    return this.http.get<any>(url).pipe(
      map((res) => res),
      (error) => error
    );
  }

  setDataVersionList() {
    const reportDataVersion = [];

    this.subscriptionManager.manage = this.retriveDataVerionList().subscribe(
      (data) => {
        data.forEach((item) => {
          const val = item.toLowerCase().replace('pcm', '');
          if (val >= '18') {
            reportDataVersion.push({
              display: 'PC*MILER '.concat(val),
              value: item,
            });
          }
        });
        reportDataVersion.reverse();
        reportDataVersion.unshift({
          display: 'Current',
          value: 'current',
        });

        sessionStorage.setItem(
          'reportDataVersion',
          JSON.stringify(reportDataVersion)
        );
        this.dataversionSource.next(reportDataVersion);
      },
      (err) => {
        const errmsg = err?.error
          ? err.error
          : 'There was an error while fecthing dataversion list from server';
        this.alertService.error(errmsg, false, 'app-modal-alert', true);
      }
    );
  }

  getDataVersionList() {
    return JSON.parse(sessionStorage.getItem('reportDataVersion'));
  }
  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe();
  }
}
